<script>
export default {
  data() {
    return {
      totalNum: 0,
      pageSize: 25,
      page: 1
    };
  },
  methods: {
    initPage() {
      this.page = 1;
    },
    sizeChange(e) {
      this.pageSize = e;
      this.page = 1;
      if (this.getList) {
        this.getList();
      }
    },
    currentChange(e) {
      this.page = e;
      if (this.getList) {
        this.getList();
      }
    },
    setTotalNum(val) {
      this.totalNum = val;
    },
    setOffset() {
      const { page, pageSize } = this;
      return {
        maxResults: page * pageSize,
        offset: (page - 1) * pageSize
      };
    }
  },
  computed: {
    maxResults() {
      const { pageSize } = this;
      return pageSize;
    },
    offset() {
      const { page, pageSize } = this;
      return (page - 1) * pageSize;
    }
  }
};
</script>